import * as types from './mutation-types'

export const communicationGetCommunications = ({ commit, state }, options) => {
  options = _.extend({
    params: {},
  }, options)

  return Vue2.prototype.$api.active().get('communications', {
    params: options.params,
  }).then((response) => {
    commit(types.COMMUNICATION_SET_COMMUNICATIONS, response.data)
  })
}

export const communicationSetBlogEntry = ({commit}, BlogEntryUuid) => {
  return Vue2.prototype.$api.active().get('communications/blog/' + BlogEntryUuid, {
    params: {
      include: 'author,categories',
    },
  }).then((response) => {
    commit(types.COMMUNICATION_SET_BLOG_ENTRY, response.data)

    return response
  })
}

export const communicationSetEmail = ({commit}, payload) => {
  return Vue2.prototype.$api.active().get('communications/emails/' + payload.uuid, {
    params: {
      include: payload.includes ? `author,${payload.includes}` : 'author',
    },
  }).then((response) => {
    commit(types.COMMUNICATION_SET_EMAIL, response.data)

    return response
  })
}

export const communicationSetSMS = ({commit}, payload) => {
  return Vue2.prototype.$api.active().get('communications/sms/' + payload.uuid, {
    params: {
      include: payload.includes ? `author,${payload.includes}` : 'author',
    },
  }).then((response) => {
    commit(types.COMMUNICATION_SET_SMS, response.data)

    return response
  })
}
export const communicationSetSMSDeliveries = ({commit}, payload) => {
  Vue2.prototype.$api.active().get('communications/sms/' + payload.uuid +'/deliveries', {
    params: {
      page: payload.page ? payload.page : 1,
      deliveryStatus: payload.status ? payload.status : null,
    },
  }).then((response) => {
    commit(types.COMMUNICATION_SET_SMS_DELIVERIES, response.data)
  })
}

export const communicationSetEmailDeliveries = ({commit}, payload) => {
  let uri = `communications/emails/${payload.uuid}/deliveries?`

  if(payload.page) {uri = uri +  `page=${payload.page}`}
  if(payload.search) {uri = uri +  `&search=${payload.search}`}
  if(payload.filter) {uri = uri +  `&filter=${payload.filter}`}

  return Vue2.prototype.$api.active().get(uri).then((response) => {
    commit(types.COMMUNICATION_SET_EMAIL_DELIVERIES, response.data)
  })
}

export const communicationGetCategories = ({commit}) => {
  return Vue2.prototype.$api.active().get('communications/categories').then((response) => {
    commit(types.COMMUNICATION_SET_CATEGORIES, response.data)

    return response
  })
}

export const communicationShareWithOrganizations = ({ commit }, payload) => {
  return Vue2.prototype.$api.active()
    .post('communications/share', payload)
    .then((response) => {
      return response
    })
}

export const communicationSetCommunicationCategoryMembershipGroups = ({ commit }, payload) => {
  return Vue2.prototype.$api.active()
    .post(`communications/categories/${payload.communicationCategoryUuid}/membership-groups/sync`, {
      membershipGroupUuids: payload.membershipGroupUuids.length ? payload.membershipGroupUuids : [],
    })
    .then((response) => {
      return response
    })
}

export const communicationRetryEmailDeliveries = ({commit}, payload) => {
  return Vue2.prototype.$api.active()
    .post(`communications/emails/${payload.emailUuid}/deliveries/retry `)
    .then((response) => {
      commit('baseAddNotification', {
        type: 'success',
        title: 'Success',
        text: response.status,
      })
    }).catch((errors) => {
      commit('baseAddNotification', {
        type: 'error',
        title: 'Error',
        text: errors.message,
      })
    })
}